import React, { useEffect, useState } from "react";

import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";

import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import RequireRoles from "../auth/RequireRoles";
import ModuleGroupsBrowser from "./ModuleGroupsBrowser";
import ModuleGroupEdit from "./edit/ModuleGroupEdit";

import { equals } from "ramda";

const ADMIN = ["ROLE_ADMIN"];

const ModuleGroupsView = () => {
  const path = useResolvedPath(".").pathname;
  const { pathname } = useLocation();

  const [isHome, setIsHome] = useState(pathname);
  useEffect(() => {
    equals(pathname, "/manage-module-groups")
      ? setIsHome(true)
      : setIsHome(false);
  }, [pathname]);

  const navigate = useNavigate();
  return (
    <Container id="manage-module-groups" disableGutters>
      <ApplicationHeader
        applicationNavigation={
          isHome ? (
            <div></div>
          ) : (
            <Button
              onClick={() => navigate(path)}
              startIcon={<ArrowBackIcon />}
            >
              Module Group Home
            </Button>
          )
        }
      />
      <Routes>
        <Route
          index
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel
                id="application-panel-module-groups"
                background="white"
              >
                <ModuleGroupsBrowser />
              </ApplicationPanel>
            </RequireRoles>
          }
        />
        <Route
          path=":id"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel
                id="application-panel-module-group-edit"
                background="white"
              >
                <ModuleGroupEdit onBack={() => navigate(path)} />
              </ApplicationPanel>
            </RequireRoles>
          }
        />
      </Routes>
    </Container>
  );
};

export default ModuleGroupsView;
